import { Auditoria } from "../../bibliotecaPjus/models/comum.models";
import { IFormulario, IModel } from "../../bibliotecaPjus/models/contrato.models";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { LIMITES_CARACTERES } from "../helper/limites-caracteres.const";

export class NegociarPropostaModel extends Auditoria implements IModel, IFormulario {

    propostaId: string;
    valorContraProposta: number;
    observacaoParceiro: string;
    form: FormGroup;

    constructor(other?: any) {
        super(other);
        if (other) {
            this.propostaId = other.propostaId;
            this.valorContraProposta = other.valorContraProposta;
            this.observacaoParceiro = other.observacaoParceiro;
        }
    }

    get asForm(): FormGroup {
        if (this.form == null) {
            this.form = new FormGroup({
                propostaId: new FormControl(this.propostaId, [Validators.required]),
                valorContraProposta: new FormControl(this.valorContraProposta, [Validators.required]),
                observacaoParceiro: new FormControl(this.observacaoParceiro, [Validators.maxLength(LIMITES_CARACTERES.OBSERVACAO)]),
            });
        }
        return this.form;
    }

    updateForm(other): void {
        this.form.patchValue(other);
    }
}
